<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Edit Manufacturer"
    icon="edit"
    :toolbarActions="[
      {
        text: 'Save',
        icon: 'save',
        buttonColor: 'success',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
        isDisabledFunc: () => !isFormValid,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
    :isLoading="isLoading"
  >
    <v-container pa-0 grid-list-lg>
      <v-form v-model="isFormValid" ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <ControlTextField
              label="Manufacturer Name*"
              autofocus
              v-model="name"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12>
            <ControlCheckbox
              v-model="isEnabled"
              label="Enabled?"
              :disabled="isLoading"
            />
          </v-flex>
        </v-layout>
        <small>*indicates required field</small>
      </v-form>
    </v-container>
  </DialogContainer>
</template>

<script>
import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlTextField from '../../../common/components/controls/ControlTextField'
import ControlCheckbox from '../../../common/components/controls/ControlCheckbox'

export default {
  components: {
    DialogContainer,
    ControlTextField,
    ControlCheckbox,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    manufacturerToEdit: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFormValid: false,
    id: null,
    name: null,
    isEnabled: null,
  }),
  watch: {
    showDialog() {
      if (this.showDialog && this.manufacturerToEdit.id) {
        this.id = this.manufacturerToEdit.id
        this.name = this.manufacturerToEdit.name
        this.isEnabled = this.manufacturerToEdit.isEnabled
      }
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        id: this.id,
        name: this.name,
        isEnabled: this.isEnabled,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.id = null
      this.name = null
      this.isEnabled = null
    },
  },
}
</script>